import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'

const H1 = styled.h1`
  color: ${props => props.headerColor};
  font-size: ${props => props.headerFontSize};
  line-height: ${props => props.headerLineHeight};
  letter-spacing: 0.025em;
  font-weight: 500;
  padding-bottom: 10px;
  text-align: ${props => (props.alignCenter ? 'center' : 'left')};
  margin-bottom: 0;
  margin-top: 0;
  @media (max-width: 768px) {
    font-size: 3rem;
    line-height: 1;
  }
`
const P = styled.p`
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
  text-align: ${props => (props.alignCenter ? 'center' : 'left')};
  color: ${props => props.headerParaColor};
  width: calc(100% - 0%);
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 1px;
  @media (max-width: 768px) {
    font-size: 15px;
    font-weight: 300;
    line-height: 1.73;
  }
  @media (max-width: 520px) {
    padding: 0;
  }
`

export class HeaderParagraph extends PureComponent {
  render() {
    const { headerColor, headerParaColor, headerFontSize, header, paragraph, alignCenter } = this.props
    return (
      <Fragment>
        <H1 headerColor={headerColor} alignCenter={alignCenter} headerFontSize={headerFontSize}>
          {header}
        </H1>
        <P alignCenter={alignCenter} headerParaColor={headerParaColor}>
          {paragraph}
        </P>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/HeaderParagraph.js